import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import AccountView from '../views/AccountView.vue'
import InvoicesView from '../views/InvoicesView.vue'
import InvoiceDetailView from '../views/InvoiceDetailView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import QuadstarPlansView from '../views/QuadstarPlansView.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/plans',
    name: 'quadstar-plans',
    component: QuadstarPlansView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { guestOnly: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/account',
    name: 'account',
    component: AccountView,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: InvoicesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices/:id',
    name: 'invoice-detail',
    component: InvoiceDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/UsersView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active'
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  const currentUser = store.getters['auth/currentUser']
  
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({ name: 'login', query: { redirect: to.fullPath } })
    } 
    // Check if route requires admin role
    else if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (currentUser && currentUser.role === 'admin') {
        next()
      } else {
        next({ name: 'dashboard' }) // Redirect non-admin users
      }
    } else {
      next()
    }
  }
  // Check if route is for guests only (like login page)
  else if (to.matched.some(record => record.meta.guestOnly)) {
    if (isLoggedIn) {
      next({ name: 'dashboard' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router